import { render, staticRenderFns } from "./zhuangchedan.vue?vue&type=template&id=1dd134cb&scoped=true&"
import script from "./zhuangchedan.vue?vue&type=script&lang=js&"
export * from "./zhuangchedan.vue?vue&type=script&lang=js&"
import style0 from "./zhuangchedan.vue?vue&type=style&index=0&id=1dd134cb&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd134cb",
  null
  
)

export default component.exports